import React from "react";

type VideoCardProps = {
  Video: any;
};

export default function TestVideoCard({ Video }: VideoCardProps) {
  return (
    <div className="rounded-lg h-full w-full">
      <div className="bg-black rounded-2xl overflow-hidden">
        <img
          src={Video.imgLink}
          className="w-full object-contain rounded max-h-[200px]"
          alt={`Thumbnail for Youtube Video titled: ${Video.title}`}
        />
      </div>
      <div className="px-4 py-3">
        <h6 className="text-base font-medium text-foreground">{Video.title}</h6>
      </div>
    </div>
  );
}
